import { CardData } from '../card-data';
import { LocationPriceStream } from '../../enum/shared/location-price-stream';
import { VariantType } from '../../enum/dto/variant-type.enum';

export class GlassHouseCardData extends CardData {
  public getSidebarText(): string {
    let strainTypesString = this.getReadableStrainType() ? this.getReadableStrainType() + ' ' : '';
    if (this.isNonCannabinoidOtherVariant()) {
      strainTypesString = '';
    }
    const variantTypeString = this.rowVariantType() || this.rowProductType();
    return `${strainTypesString}${variantTypeString}`.trim();
  }

  /**
   * ⚠️ WARNING: This method is also used as the price override in the Glass House Price component.
   * Modifying it will affect the "Out the Door" price displayed on the card.
   */
  override getOverridePriceStreamForLabelComponent(): LocationPriceStream {
    return LocationPriceStream.TaxesIn;
  }

  /**
   * Due to regulatory requirements, Glass House cannot use the term “Disposable Vape” on printed materials
   * and requires the wording to be displayed as “All In One Vape.”
   */
  override rowVariantType(): VariantType | null {
    const type = super.rowVariantType();
    if (type === VariantType.DisposableVape) {
      return 'All In One Vape' as VariantType;
    }
    return type;
  }
}
